import { jsConfigOverride } from '@fcom/server/server/jsConfigOverride';

import { JsConfig } from '../../interfaces';
import { environment } from '../../../../environments/environment';

export const isNodeEnvironment = (): boolean => {
  return (
    (typeof process !== 'undefined' && process.versions?.node != null) ||
    (typeof global !== 'undefined' && typeof window === 'undefined')
  );
};

export const getJsConfig = (
  env: JsConfig = environment,
  nodeOverrides: Partial<JsConfig> = jsConfigOverride,
  browserOverrides: Partial<JsConfig> = typeof window !== 'undefined' ? (window['jsConfigOverride'] ?? {}) : {}
): JsConfig => {
  const overrides = isNodeEnvironment() ? nodeOverrides : browserOverrides;
  return { ...env, ...overrides };
};

export const jsConfig = getJsConfig();
